import { DiagnosisDraft } from '../DocumentEngagements/DiagnosisDraft.model';

export default interface IMemberEncounterDraft {
    Id: string;
    CptCodeId: string;
    CptCode: string;
}

export class MemberEncounterDraft implements IMemberEncounterDraft {
    Id: string;
    CptCodeId: string;
    CptCode: string;
    PrimaryDiagnosis: DiagnosisDraft;
    SecondaryDiagnosis: DiagnosisDraft;
    TertiaryDiagnosis: DiagnosisDraft;
    QuaternaryDiagnosis: DiagnosisDraft;
    AdditionalDiagnosis: DiagnosisDraft[];
    DiagnosisList: DiagnosisDraft[];
    IsSummaryNote: boolean;
    CptCodeOder: number;
    CategoryGroupId: string;
    MemberId: string;
    EngagementId?: string;
    Units: number;
    Modifier: string;
    Modifier2: string;
    Modifier3: string;
    Modifier4: string;
    tempId: string;
    PlaceOfEncounterId: string;
    PlaceOfEncounterValue: number;
    ServiceDate: string;
    TraceId: string;
    IsNotEncounterable: boolean;

    constructor() {
        this.Id = '';
        this.CptCodeId = '';
        this.CptCode = '';
    }
}
